export default __webpack_public_path__ + "static/media/timer-alarm.da946ff5.mp3";